import { Typography } from '@sonnen/web-ui';
import OptimizationCard from '../../components/OptimizationCard/OptimizationCard';
import { useTranslation } from '../../i18n/i18n';
import styles from './EnergyStore.module.css';

export const EnergyStoreSideCards = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.optimizationCardsWrapper} data-testid="energy-store-side-cards">
      <Typography.H5>{t('energyStore.optimization.title')}</Typography.H5>
      <div className={styles.cardsWrapper} data-testid="energy-store-optimization-cards">
        <OptimizationCard scope="batteryOptimization" />
        <OptimizationCard scope="selfConsumption" />
      </div>
    </div>
  );
};
